<template>
  <div>
    <b-modal v-if="!modaldel" id="modal-1" hide-footer title="Supprimer">
      <!-- <form @submit=""> -->
      <p class="my-4">Voulez vous supprimer</p>
      <hr class="my-4" />
      <center>
        <b-btn type="button" style="background-color:#c2b59b;color:#fff">non</b-btn>
        <b-btn
          type="button"
          @click="deleteclient(user.id)"
          style="background-color:#c2b59b;color:#fff"
        >oui</b-btn>
      </center>
      <!-- </form> -->
    </b-modal>
  </div>
</template>
<script>
import { setToken, del } from "@/mixins/api";
export default {
  name: "ModalDeleteClient",
  components: {},

  data() {
    return {
      modaldel: false,
      user: {
        id: "",
        fullname: "",
        email: "",
        address: "",
        phonenumber: ""
      },
      userToken:
        localStorage.getItem("userToken") ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTU3OTczNDkxMSwiZXhwIjoxNjExMjcwOTExfQ.96_I_ZUs7ALBMY4pDsnjbT-fvvagVMsVlpi48eAKWGk"
    };
  },
  methods: {
    getClient(data) {
      console.log(data);
      this.user = data;
    },
    deleteclient(id) {
      del("client/" + id).then(resp => {
        this.output = resp.data.data;
        this.modaldel = false
        this.$emit("clientsadd");

      });
      this.modaldel = true;
    }
  },

  mounted() {
    setToken(this.userToken);
    //this.loadData();
  }
};
</script>
                        